import React, { Component } from 'react';
import { Link } from 'react-router-dom';

function ChessRow(props){
  const items = []
  let inNumber = false;
  let currentNumber = 0;
  let position = 0;

  for (let i = 1; i < 9; i++) {
    let id = props.rowNum + i;
    let color = (Number(props.rowNum) + i)%2 == 1 ? props.squareColor : "white";
    let piece = '';
    if(inNumber == false)
    {
      let currentPiece = props.pieces[position];
      if(isNaN(currentPiece))
      {
        if(props.pieceType=="solid")
        {
          piece = GetChessPiece(currentPiece);
        }
        else if(props.pieceType=="image")
        {
          piece = GetChessImage(currentPiece);
        }
        else
        {
         piece = GetChessUnicode(currentPiece);
        }
      }
      else
      {
        // todo: is this needed?
         currentNumber = currentPiece;
         if(currentPiece > 1)
         {
           inNumber = true;
         }
      }
      position++;
    }
    else
    {
      currentNumber--;
      if(currentNumber <= 1)
      {
         inNumber = false;
      }
    }
    if(props.pieceType=="solid")
    {
      if(piece == '')
      {
        items.push(<div id = {id} className={color} ></div>)
      }
      else
      {
        //console.log(piece)
        items.push(<div id = {id} draggable="false" className={color} style={{backgroundImage: 'url("//images.chesscomfiles.com/chess-themes/pieces/classic/150/' + piece + '.png")',backgroundSize: '50px 50px'}}></div>)
      }
    }
    else if(props.pieceType=="image")
    {
      if(piece == '')
      {
        items.push(<div id = {id} className={color} ></div>)
      }
      else
      {
        items.push(<div id = {id} draggable="false" className={color} style={{backgroundImage: 'url("/assets/images/' + piece + '.png")',backgroundSize: '50px 50px'}}></div>)
      }
    }
    else
    {
      items.push(<div id = {id} draggable="false" className={color} >{piece}</div>)
    }
  }

  return (
    <div className="row">
      {items}
    </div>
  )
}

function GetChessUnicode(cp)
{
  switch (cp) {
  case 'p':
    return "\u265F";
    break;
  case 'P':
    return "\u2659";
    break;
  case 'r':
     return "\u265C";
    break;
  case 'R':
    return "\u2656";
    break;
  case 'n':
    return "\u265E";
    break;
  case 'N':
    return "\u2658";
    break;
  case 'b':
    return "\u265D";
    break;
  case 'B':
    return "\u2657";
    break;
  case 'q':
    return "\u265B";
    break;
  case 'Q':
     return "\u2655";
    break;
  case 'k':
    return "\u265A";
    break;
  case 'K':
    return "\u2654";
    break;
 }
}

function GetChessImage(cp)
{
  switch (cp) {
  case 'p':
    return "bP";
    break;
  case 'P':
    return "wP";
    break;
  case 'r':
     return "bR";
    break;
  case 'R':
    return "wR";
    break;
  case 'n':
    return "bN";
    break;
  case 'N':
    return "wN";
    break;
  case 'b':
    return "bB";
    break;
  case 'B':
    return "wB";
    break;
  case 'q':
    return "bQ";
    break;
  case 'Q':
     return "wQ";
    break;
  case 'k':
    return "bK";
    break;
  case 'K':
    return "wK";
    break;
 }
}

 function GetChessPiece(cp)
 {
   switch (cp) {
   case 'p':
     return "bp";
     break;
   case 'P':
     return "wp";
     break;
   case 'r':
      return "br";
     break;
   case 'R':
     return "wr";
     break;
   case 'n':
     return "bn";
     break;
   case 'N':
     return "wn";
     break;
   case 'b':
     return "bb";
     break;
   case 'B':
     return "wb";
     break;
   case 'q':
     return "bq";
     break;
   case 'Q':
      return "wq";
     break;
   case 'k':
     return "bk";
     break;
   case 'K':
     return "wk";
     break;
  }
}

class Chess extends Component {

  constructor(props) {
        super(props);

    }

    render() {
     if (this.props.fen === '')
     {
        return null;
     }

      var res = this.props.fen.split("/");
      var color = this.props.squareColor
      var pieceType = this.props.pieceType
      return(
        <div className="chessboard">
          <ChessRow rowNum="1" pieces={res[0]} squareColor={color} pieceType={pieceType}/>
          <ChessRow rowNum="2" pieces={res[1]} squareColor={color} pieceType={pieceType}/>
          <ChessRow rowNum="3" pieces={res[2]} squareColor={color} pieceType={pieceType}/>
          <ChessRow rowNum="4" pieces={res[3]} squareColor={color} pieceType={pieceType}/>
          <ChessRow rowNum="5" pieces={res[4]} squareColor={color} pieceType={pieceType}/>
          <ChessRow rowNum="6" pieces={res[5]} squareColor={color} pieceType={pieceType}/>
          <ChessRow rowNum="7" pieces={res[6]} squareColor={color} pieceType={pieceType}/>
          <ChessRow rowNum="8" pieces={res[7]} squareColor={color} pieceType={pieceType}/>
       </div>
    );

  }
}

export default Chess;
